import { render, staticRenderFns } from "./transAnomaly.vue?vue&type=template&id=e60fc0b8&scoped=true"
import script from "./transAnomaly.vue?vue&type=script&lang=js"
export * from "./transAnomaly.vue?vue&type=script&lang=js"
import style0 from "./transAnomaly.vue?vue&type=style&index=0&id=e60fc0b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60fc0b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e60fc0b8')) {
      api.createRecord('e60fc0b8', component.options)
    } else {
      api.reload('e60fc0b8', component.options)
    }
    module.hot.accept("./transAnomaly.vue?vue&type=template&id=e60fc0b8&scoped=true", function () {
      api.rerender('e60fc0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/cmp/transAnomaly.vue"
export default component.exports